import { Store } from "../../../flux/Store";
import { names } from "./FlagActions";

export interface FlagStoreState
{
    isSet: boolean;
}

// This is a Flux store which handles single boolean value
// This used to show/hide spinners mainly
export class FlagStore extends Store<FlagStoreState>
{
    constructor()
    {
        super();
        this.state = { isSet: false };

        this.register(names.SET, e => {
            if(e.meta === this.dispatchToken)
                return this.field({ isSet: true });
        });
        this.register(names.RESET, e => {
            if(e.meta === this.dispatchToken)
                return this.field({ isSet: false });
        });
    }

    isSet = () => this.state.isSet;
}


// WEBPACK FOOTER //
// ./src/app/flux/Flag/FlagStore.ts